import React from 'react';
import styles from './SimpleError.module.scss';

export default function SimpleError({ error }: { error: string | undefined }) {
  return error ? <div className={styles.simpleError}>{error}</div> : null;
}
